import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

Sentry.init({
  dsn: "https://63e0059db369e5b4aec39183863ab3a6@o4510655499403264.ingest.us.sentry.io/4510655526141952",
  sendDefaultPii: true,
  // Only enable in production
  enabled: import.meta.env.PROD,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance monitoring sample rate
  tracesSampleRate: 1.0,
  // Session replay sample rates
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

createRoot(document.getElementById("root")!).render(<App />);
